import { render, staticRenderFns } from "./FormInbox.vue?vue&type=template&id=06526804&"
import script from "./FormInbox.vue?vue&type=script&lang=js&"
export * from "./FormInbox.vue?vue&type=script&lang=js&"
import style0 from "./FormInbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports